import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';

import './Success.css';

const CELL_PADDING = '5px';

export const Success = ({ ticketNumber }) => {
  return (
    <Container className="Success">
      <Card.Title>Thank you!</Card.Title>
      <Card.Body>
        <p>We'll be in touch soon.</p>
        {ticketNumber && (
          <>
            <p>
              Your ticket number is:{' '}
              <span className="Success-TicketNumber">{ticketNumber}</span>
            </p>
            <p>
              NOTE:
              <br />
              <br />
              <a href="mailto:support@ciunetworks.com?subject={ticketNumber} - Requesting Scheduled Appointment">
                If you need to schedule support at a specific time or location,
                please email support@ciunetworks.com.
              </a>
              <br />
              <br />
              Be sure to include your ticket #{' '}
              <span className="Success-TicketNumber">{ticketNumber}</span> on
              the subject line and our dispatch team will reach out to you as
              soon as possible.
            </p>
          </>
        )}
      </Card.Body>
    </Container>
  );
};
